import React from 'react';
import { Icon } from 'semantic-ui-react';
import Tooltips from 'components/Tooltip';
import { useTranslation } from 'react-i18next';

const ConsoleModal = ({ handleConsoleOpen }) => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <Tooltips title={t('vs/instance.string28')}>
        <span>
          <Icon size="large" name="keyboard outline" onClick={handleConsoleOpen} />
        </span>
      </Tooltips>
    </React.Fragment>
  );
};
export { ConsoleModal };
